var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { hostedFields, dataCollector } from "braintree-web";
import { useBraintreeClient } from "../../app/useBraintreeClient";
import { usePayment } from "../../app/usePayment";
import { useNotifications } from "../../app/useNotifications";
import { useLoader } from "../../app/useLoader";
import { HOSTED_FIELDS_LABEL, HOSTED_FIELDS, renderMaskButtonClasses, } from "../../styles";
export var CreditCardMask = function (_a) {
    var _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, buttonText = _a.buttonText, showPostalCode = _a.showPostalCode, threeDSAdditionalInformation = _a.threeDSAdditionalInformation, threeDSBillingAddress = _a.threeDSBillingAddress, showCardHoldersName = _a.showCardHoldersName, enableVaulting = _a.enableVaulting, _c = _a.continueOnLiabilityShiftPossible, continueOnLiabilityShiftPossible = _c === void 0 ? false : _c, _d = _a.continueOnNoThreeDS, continueOnNoThreeDS = _d === void 0 ? false : _d, useKount = _a.useKount, lineItems = _a.lineItems, shipping = _a.shipping, _e = _a.isPureVault, isPureVault = _e === void 0 ? false : _e;
    var _f = usePayment(), handlePurchase = _f.handlePurchase, handlePureVault = _f.handlePureVault, paymentInfo = _f.paymentInfo, handleGetVaultedPaymentMethods = _f.handleGetVaultedPaymentMethods, braintreeCustomerId = _f.braintreeCustomerId;
    var notify = useNotifications().notify;
    var isLoading = useLoader().isLoading;
    var _g = useState(false), hostedFieldsCreated = _g[0], setHostedFieldsCreated = _g[1];
    var _h = useState(false), showNewCreditCardForm = _h[0], setShowNewCreditCardForm = _h[1];
    var _j = useState(true), emptyInputs = _j[0], setEmptyInputs = _j[1];
    var _k = useState(false), invalidInput = _k[0], setInvalidInput = _k[1];
    var _l = useState(""), deviceData = _l[0], setDeviceData = _l[1];
    var _m = useState([]), limitedVaultedPayments = _m[0], setLimitedVaultedPaymentMethods = _m[1];
    var _o = useState(""), selectedCard = _o[0], setSelectedCard = _o[1];
    var _p = useBraintreeClient(), client = _p.client, threeDS = _p.threeDS;
    var ccFormRef = React.useRef(null);
    var ccNumberRef = React.useRef(null);
    var ccNameRef = React.useRef(null);
    var ccCvvRef = React.useRef(null);
    var ccPostalRef = React.useRef(null);
    var ccExpireRef = React.useRef(null);
    var ccVaultCheckbox = React.useRef(null);
    var borderClassToggle = ["border-2", "border-rose-600"];
    var FieldKeyMap = {
        number: ccNumberRef,
        cvv: ccCvvRef,
        expirationDate: ccExpireRef,
        cardholderName: ccNameRef,
        postalCode: ccPostalRef,
    };
    var handleGetVaultedPaymentMethodsByType = function (type) {
        if (isPureVault) {
            setHostedFieldsCreated(true);
            return;
        }
        var filteredPaymentMethods = [];
        handleGetVaultedPaymentMethods()
            .then(function (paymentMethods) {
            paymentMethods.forEach(function (paymentMethod) {
                if (paymentMethod.type === type) {
                    filteredPaymentMethods.push({
                        nonce: paymentMethod.nonce,
                        details: paymentMethod.details,
                    });
                }
            });
            setLimitedVaultedPaymentMethods(filteredPaymentMethods);
        })
            .finally(function () { return setHostedFieldsCreated(true); });
    };
    var verifyCardAndHandlePurchase = function (threeDSecureParameters, shouldVault) {
        var options = {
            deviceData: deviceData,
        };
        if (shouldVault) {
            options.shouldVault = true;
        }
        if (lineItems) {
            options.lineItems = lineItems;
        }
        if (shipping) {
            options.shipping = shipping;
        }
        threeDS
            .verifyCard(threeDSecureParameters)
            .then(function (response) {
            if (response.threeDSecureInfo.status !== "authenticate_successful") {
                isLoading(false);
                notify("Error", "Could not authenticate");
                return;
            }
            if (response.threeDSecureInfo.liabilityShifted) {
                handlePurchase(response.nonce, options);
            }
            else if (response.threeDSecureInfo.liabilityShiftPossible) {
                if (continueOnLiabilityShiftPossible) {
                    handlePurchase(response.nonce, options);
                }
                else {
                    notify("Warning", "Failed the 3D Secure verification. Please use a different payment method.");
                }
            }
            else {
                if (continueOnNoThreeDS) {
                    handlePurchase(response.nonce, options);
                }
                else {
                    notify("Warning", "3D Secure is not available for your card. Please use a different payment method.");
                }
            }
        })
            .catch(function (error) {
            isLoading(false);
            if ((error === null || error === void 0 ? void 0 : error.code.indexOf("THREEDS_LOOKUP")) === 0) {
                if (error.code === "THREEDS_LOOKUP_TOKENIZED_CARD_NOT_FOUND_ERROR") {
                    notify("Error", "Payment nonce does not exist or was already used");
                }
                else if (error.code.indexOf("THREEDS_LOOKUP_VALIDATION") === 0) {
                    notify("Error", "Validation error - check your input or try a different payment");
                }
                else {
                    notify("Error", "Something went wrong - try again");
                }
            }
            else {
                notify("Error", "Something went wrong - try again");
            }
        });
    };
    useEffect(function () {
        if (!client || !threeDS)
            return;
        isLoading(true);
        var form = ccFormRef.current;
        var hostedFieldsInputs = {
            number: {
                container: "#card-number",
                placeholder: "4111 1111 1111 1111",
            },
            cvv: {
                container: "#cvv",
                placeholder: "123",
            },
            expirationDate: {
                container: "#expiration-date",
                placeholder: "MM/YYYY",
            },
        };
        if (showPostalCode) {
            hostedFieldsInputs = __assign(__assign({}, hostedFieldsInputs), { postalCode: {
                    container: "#postal-code",
                } });
        }
        if (showCardHoldersName) {
            hostedFieldsInputs = __assign(__assign({}, hostedFieldsInputs), { cardholderName: {
                    container: "#cc-name",
                    placeholder: "name",
                } });
        }
        hostedFields.create({
            client: client,
            styles: {
                input: {
                    "font-size": "16px",
                    "font-family": "courier, monospace",
                    "font-weight": "lighter",
                    color: "#ccc",
                },
                ":focus": {
                    color: "black",
                },
                ".valid": {
                    color: "#8bdda8",
                },
                ".invalid": {
                    color: "#DE7976",
                },
            },
            fields: __assign({}, hostedFieldsInputs),
        }, function (err, hostedFieldsInstance) {
            if (err) {
                isLoading(false);
                notify("Error", "Something went wrong.");
                console.error(err);
                return;
            }
            if (!hostedFieldsInstance || !form) {
                isLoading(false);
                notify("Error", "Credit card fields are not available.");
                return;
            }
            hostedFieldsInstance.on("notEmpty", function (event) {
                var isEmpty = false;
                var fieldsKey;
                for (fieldsKey in event.fields) {
                    isEmpty = isEmpty || event.fields[fieldsKey].isEmpty;
                }
                setEmptyInputs(isEmpty);
            });
            hostedFieldsInstance.on("empty", function (event) {
                setEmptyInputs(true);
            });
            hostedFieldsInstance.on("validityChange", function (event) {
                var isValid = true;
                var fieldsKey;
                var _loop_1 = function () {
                    var validField = event.fields[fieldsKey].isValid ||
                        event.fields[fieldsKey].isPotentiallyValid;
                    isValid = isValid && validField;
                    borderClassToggle.map(function (classToggle) {
                        var _a;
                        return (_a = FieldKeyMap[fieldsKey].current) === null || _a === void 0 ? void 0 : _a.classList.toggle(classToggle, !validField);
                    });
                };
                for (fieldsKey in event.fields) {
                    _loop_1();
                }
                setInvalidInput(!isValid);
            });
            dataCollector.create({
                client: client,
                paypal: true,
                kount: useKount !== null && useKount !== void 0 ? useKount : undefined,
            }, function (dataCollectorErr, dataCollectorInstance) {
                if (!dataCollectorErr && dataCollectorInstance) {
                    setDeviceData(dataCollectorInstance.deviceData);
                }
            });
            var tokenize = function (event) {
                var _a;
                event.preventDefault();
                isLoading(true);
                var shouldVault = ((_a = ccVaultCheckbox.current) === null || _a === void 0 ? void 0 : _a.checked) || false;
                hostedFieldsInstance.tokenize({ vault: shouldVault }, function (err, payload) {
                    if (err || !payload) {
                        isLoading(false);
                        notify("Error", "Something went wrong. Check your card details and try again.");
                        return;
                    }
                    if (isPureVault) {
                        handlePureVault(payload.nonce);
                    }
                    else {
                        var threeDSecureParameters = {
                            amount: paymentInfo.amount,
                            nonce: payload.nonce,
                            bin: payload.details.bin,
                            email: paymentInfo.cartInformation.account.email,
                            billingAddress: threeDSBillingAddress,
                            additionalInformation: threeDSAdditionalInformation,
                        };
                        verifyCardAndHandlePurchase(threeDSecureParameters, shouldVault);
                    }
                });
            };
            form.addEventListener("submit", tokenize, false);
            handleGetVaultedPaymentMethodsByType("CreditCard");
            isLoading(false);
        });
    }, [client, threeDS]);
    var changeCard = function (e) {
        var value = parseInt(e.target.value);
        var checkNew = value === -1;
        if (checkNew) {
            setSelectedCard("new");
        }
        else {
            var vaultedPayment = limitedVaultedPayments[value];
            setSelectedCard({
                nonce: vaultedPayment.nonce,
                bin: vaultedPayment.details.bin,
            });
        }
        setShowNewCreditCardForm(checkNew);
    };
    var submitVaultedCard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var threeDSecureParameters;
        return __generator(this, function (_a) {
            if (!threeDS) {
                notify("Error", "3D Secure could not load");
                return [2 /*return*/];
            }
            if (selectedCard === "" || selectedCard === "new") {
                notify("Error", "An error occurred");
                return [2 /*return*/];
            }
            isLoading(true);
            threeDSecureParameters = {
                amount: paymentInfo.amount,
                nonce: selectedCard.nonce,
                bin: selectedCard.bin,
                email: paymentInfo.cartInformation.account.email,
                billingAddress: threeDSBillingAddress,
                additionalInformation: threeDSAdditionalInformation,
            };
            verifyCardAndHandlePurchase(threeDSecureParameters);
            isLoading(false);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (!hostedFieldsCreated || limitedVaultedPayments.length) {
            setShowNewCreditCardForm(false);
            setSelectedCard("");
            return;
        }
        setShowNewCreditCardForm(true);
        setSelectedCard("new");
    }, [limitedVaultedPayments, hostedFieldsCreated]);
    return (_jsxs(_Fragment, { children: [_jsx(_Fragment, { children: !!limitedVaultedPayments.length && (_jsxs("div", __assign({ className: "block w-full" }, { children: [_jsx(_Fragment, { children: limitedVaultedPayments.map(function (vaultedMethod, index) {
                                return (_jsxs("div", __assign({ className: "flex gap-x-5 justify-start content-center border p-2 border-gray-300 rounded mt-4" }, { children: [_jsx("input", { className: "w-3 justify-self-center", id: "credit-card-".concat(index), type: "radio", name: "select-credit-card", value: index, onChange: changeCard }), _jsxs("label", __assign({ htmlFor: "credit-card-".concat(index), className: "cursor-pointer w-full" }, { children: [_jsx("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: vaultedMethod.details.cardType })), _jsxs("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: ["**** **** **** ", vaultedMethod.details.lastFour] })), _jsx("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: vaultedMethod.details.cardholderName })), _jsxs("span", __assign({ className: HOSTED_FIELDS_LABEL }, { children: [vaultedMethod.details.expirationMonth, " /", " ", vaultedMethod.details.expirationYear] }))] }))] }), index));
                            }) }), _jsxs("label", __assign({ className: "".concat(HOSTED_FIELDS_LABEL, " mt-2 mb-2") }, { children: [_jsx("input", { type: "radio", name: "select-credit-card", value: "-1", onChange: changeCard, className: "mr-2" }), "new credit card"] }))] }))) }), _jsx("div", __assign({ className: classNames({
                    "demo-frame": true,
                    hidden: !showNewCreditCardForm,
                }) }, { children: _jsxs("form", __assign({ ref: ccFormRef, action: "/", method: "post", id: "cardForm", className: "m-auto p-8 max-w-screen-md" }, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "card-number" }, { children: "Card Number" })), _jsx("div", { ref: ccNumberRef, id: "card-number", className: "".concat(HOSTED_FIELDS, " px-3") }), showCardHoldersName && (_jsxs(_Fragment, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "cc-name" }, { children: "Name" })), _jsx("div", { ref: ccNameRef, id: "cc-name", className: "".concat(HOSTED_FIELDS, " p-3") })] })), _jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "expiration-date" }, { children: "Expiration Date" })), _jsx("div", { ref: ccExpireRef, id: "expiration-date", className: "".concat(HOSTED_FIELDS, " p-3") }), showPostalCode && (_jsxs(_Fragment, { children: [_jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "postal-code" }, { children: "Postal code" })), _jsx("div", { ref: ccPostalRef, id: "postal-code", className: "".concat(HOSTED_FIELDS, " p-3") })] })), _jsx("label", __assign({ className: HOSTED_FIELDS_LABEL, htmlFor: "cvv" }, { children: "CVV" })), _jsx("div", { ref: ccCvvRef, id: "cvv", className: "".concat(HOSTED_FIELDS, " p-3") }), enableVaulting && braintreeCustomerId && (_jsx(_Fragment, { children: _jsxs("label", __assign({ className: "".concat(HOSTED_FIELDS_LABEL, " mb-2") }, { children: [_jsx("input", { className: "mr-3", ref: ccVaultCheckbox, type: "checkbox" }), "Save my card"] })) })), _jsx("div", __assign({ className: "block text-center" }, { children: selectedCard === "new" && (_jsx("input", { disabled: emptyInputs && invalidInput, type: "submit", className: renderMaskButtonClasses(fullWidth, !(emptyInputs && invalidInput), emptyInputs || invalidInput), value: buttonText, id: "submit" })) }))] })) })), selectedCard && selectedCard !== "new" && (_jsx("div", __assign({ className: "m-auto p-8 max-w-screen-md" }, { children: _jsx("button", __assign({ onClick: submitVaultedCard, className: renderMaskButtonClasses(fullWidth, true, false) }, { children: buttonText })) })))] }));
};
